import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const AlarmModalHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  const btnFontSubURL = getFontURL(btnFontFamily?.sub_button);
  const btnFontNeverShowURL = getFontURL(btnFontFamily?.never_show_button);

  const alarmImageUrl =
    'https://i.ibb.co/02BwCVy/Kakao-Talk-20210125-102652294-1.png';
  const style = `

   @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }

  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }

    @font-face {
      font-family: 'btnFont';
      src: url(${btnFontURL});
      }
  
    @font-face {
      font-family: 'btnSubFont';
      src: url(${btnFontSubURL});
      }
  
    @font-face {
      font-family: 'btnNeverShowFont';
      src: url(${btnFontNeverShowURL});
      }
  

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 1rem 1rem 1rem;

      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .alarm {
      text-align: center;
    }
    .alarm button {
      width: 3rem;
      height: 3rem;
      
      background-image: url(${alarmImageUrl});
      background-repeat: no-repeat;
      background-size: 3rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .title {
      height: 3.5rem;
      display: flex;
      align-items: center;
    }
    .title_inner {
      width: 100%;
      height: auto;
      max-height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'titleFont'
      };
    }
    .sub_title {
      height: 3rem;
      display: flex;
      align-items: center;
    }
    .sub_title_inner {
      width: 100%;
      height: auto;
      max-height: 2.6rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitleFont'
      }
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btnFont'
      };

      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
      height: 1.25rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.never_show_button};
      font-weight: ${btnFontWeight?.never_show_button};
      font-size: ${btnFontSize?.never_show_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.never_show_button
        )
          ? btnFontFamily.never_show_button
          : 'btnNeverShowFont'
      };
      background-color:rgba(${btnBgColorR?.never_show_button},${
    btnBgColorG?.never_show_button
  }, ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.sub_button};
      font-weight: ${btnFontWeight?.sub_button};
      font-size: ${btnFontSize?.sub_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.sub_button
        )
          ? btnFontFamily.sub_button
          : 'btnSubFont'
      };
      background-color:rgba(${btnBgColorR?.sub_button},${
    btnBgColorG?.sub_button
  }, ${btnBgColorB?.sub_button}, ${btnBgColorA?.sub_button});
    }

		@media screen and (min-width: 600px) and (max-width: 1024px) {
      .center {
        width: 50%;
      }
      .modal_wrapper {
        padding: 2rem;
      }

      .title {
        height: 4.5rem;
      }
      .title_inner {
        max-height: 3.8rem;
        font-size: ${fontSize?.title + 0.5}rem;
      }
      .sub_title {
        height: 4rem;
      }
      .sub_title_inner {
        font-size: ${fontSize?.sub_title + 0.125}rem;
      }

      .bottom_wrapper .style01 {
        font-size: ${btnFontSize?.never_show_button + 0.25}rem;
      }
      .bottom_wrapper .style02 {
        font-size: ${btnFontSize?.sub_button + 0.25}rem;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="center">
        <div class="modal_wrapper">
          <div class="alarm">
            <button>alarm</button>
          </div>
          <div>
            <div class="title">
              <div class="title_inner">${changeEnterHTML(text?.title)}</div>
            </div>
            <div class="sub_title">
              <div class="sub_title_inner">${changeEnterHTML(
                text?.sub_title
              )}</div>
            </div>
          </div>
          <div class="btn_wrapper">
            <button class="btn_inner">
              ${btnText?.button}
            </button>
          </div>
        </div>
        <div class="bottom_wrapper">
          <span class="style01">
            ${btnText?.never_show_button}
          </span>
          <span class="style02">${btnText?.sub_button}</span>
        </div>
      </div>
    </div>
  `;

  let tracking_list = '[';
  for (let i = 0; i < tracking?.button?.length; i++) {
    tracking_list += `['${tracking?.button?.[i]}', '${tracking?.left_button?.[i]}', '${tracking?.right_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList('ALARM MODAL', button1, button2);

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.btn_wrapper').click(function() {
      appboyBridge.logClick(tracking[0][0]);
      try {
        if (button1[0].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = '${deeplink?.background}';
    });
    $('.style01').click(function() {
      appboyBridge.getUser().setCustomUserAttribute("don't show today", new Date());
      appboyBridge.logCustomEvent("don't show again");
      appboyBridge.logClick(tracking[0][1]);
      try {
        if (button1[1].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.style02').click(function() {
      appboyBridge.logClick(tracking[0][2]);
      try {
        if (button1[2].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default AlarmModalHTML;
